<template>
    <div>
        <vx-card title="Package activations" id="activationsDiv"  class="vs-con-loading__container">
            <vs-table ref="activationsTable" :data="tableData" pagination search :maxItems="itemsPerPage">

                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                    <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4" v-if="tableData.length > 0">
                        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ tableItems - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : tableItems }} of {{ tableItems }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>

                        <vs-dropdown-menu>

                            <vs-dropdown-item @click="itemsPerPage=10">
                                <span>10</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=20">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=50">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=100">
                                <span>100</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=250">
                                <span>250</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=500">
                                <span>500</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=1000">
                                <span>1000</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <template slot="thead">
                    <vs-th sort-key="package_name">Name</vs-th>
                    <vs-th sort-key="activation_time">Activation time</vs-th>
                    <vs-th sort-key="start_time">Start time</vs-th>
                    <vs-th sort-key="end_time">End time</vs-th>
                    <vs-th sort-key="trial_activation">Trial</vs-th>
                    <vs-th sort-key="credits">Credits</vs-th>
                    <vs-th sort-key="enabled">Disable</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :key="index" v-for="(tr, index) in data">

                        <vs-td :data="data[index].package_name">
                            {{ data[index].package_name }}
                        </vs-td>

                        <vs-td :data="data[index].activation_time">
                            {{ moment(data[index].activation_time).format("YYYY/MM/DD HH:mm:ss") }}
                        </vs-td>

                        <vs-td :data="data[index].start_time">
                            {{ moment(data[index].start_time).format("YYYY/MM/DD HH:mm:ss") }}
                        </vs-td>

                        <vs-td :data="data[index].end_time">
                            {{ moment(data[index].end_time).format("YYYY/MM/DD HH:mm:ss") }}
                        </vs-td>

                        <vs-td :data="data[index].trial_activation" class="flex pt-5">
                            <vs-chip v-if="data[index].trial_activation" color="success">Yes</vs-chip>
                            <vs-chip v-else color="danger">No</vs-chip>
                        </vs-td>

                        <vs-td :data="data[index].credits">
                            {{ data[index].credits }}
                        </vs-td>

                        <vs-td :data="data[index].enabled">
                            <vs-chip color="danger" v-if="!data[index].enabled">Disabled</vs-chip>
                            <vs-button icon-pack="feather" icon="icon-x" v-else color="danger" @click="disableActivation(data[index].id)"/>
                        </vs-td>

                    </vs-tr>
                </template>
            </vs-table>
        </vx-card>
    </div>
</template>
<script>

    export default {

        props: {

            clientId: {
                type: Number,
                required: true
            }
        },
        data() {
            return {

                itemsPerPage: 10,
                isMounted: false,

                activations: []
            }
        },
        methods: {
            loadData() {
                this.$vs.loading({
                    container: '#activationsDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const activationsPromise = this.$http.get('/api/management/v1/client/' + this.clientId + '/activation')
                activationsPromise.then(function(response) {
                    thisIns.activations = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#activationsDiv > .con-vs-loading')
                })
            },
            disableActivation(id) {
                this.$vs.loading({
                    container: '#activationsDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const disablePromise = this.$http.put('/api/management/v1/package_activation/' + id + '/disable')
                disablePromise.then(function() {
                    thisIns.loadData()
                    thisIns.$emit('disable')
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#activationsDiv > .con-vs-loading')
                })
            }
        },
        computed: {
            currentPage() {
                if (this.isMounted) {
                    return this.$refs.activationsTable.currentx
                }
                return 0
            },
            tableItems() {
                if (this.isMounted) {
                    return this.$refs.activationsTable.queriedResults.length
                }
                return 0
            },
            tableData() {
                return this.activations
            }
        },
        mounted() {
            this.isMounted = true
            this.loadData()
        }

    }

</script>
